/**
 * メインアプリケーションコンポーネント
 *
 * React Routerを使用してSPAのルーティングを管理。
 * react-helmet-asyncでhead要素を管理。
 *
 */

import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import {
  TopPage,
  WorksList,
  WorkDetail,
  EventsList,
  EventDetail,
  TimelinePage,
  AboutPage,
  MetadataPage,
} from '@/pages';
import { useLanguageStore } from '@/stores/language-store';

/**
 * App コンポーネント
 */
export function App() {
  // 言語 state を DOM の lang 属性に同期
  const language = useLanguageStore((state) => state.language);
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <HelmetProvider>
      <Routes>
        {/* SC-01: トップページ */}
        <Route path="/" element={<TopPage />} />

        {/* SC-02: 作品一覧 */}
        <Route path="/works" element={<WorksList />} />

        {/* SC-03: 作品詳細 */}
        <Route path="/works/:id" element={<WorkDetail />} />

        {/* SC-04: イベント一覧 */}
        <Route path="/events" element={<EventsList />} />

        {/* SC-05: イベント詳細 */}
        <Route path="/events/:id" element={<EventDetail />} />

        {/* SC-06: タイムライン */}
        <Route path="/timeline" element={<TimelinePage />} />

        {/* About ページ */}
        <Route path="/about" element={<AboutPage />} />

        {/* Metadata ページ */}
        <Route path="/metadata" element={<MetadataPage />} />

        {/* 404 Not Found（将来実装） */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </HelmetProvider>
  );
}
